import React from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { Helmet } from 'react-helmet-async';
export function DmcaPage() {
  return <>
      <Helmet data-id="element-190" data-mp="1olvkqozqvg6u">
        <title data-id="element-191" data-mp="1omdjbs9vq6hx">DMCA Policy - Fifth Door</title>
        <meta name="description" content="Fifth Door DMCA Policy." data-id="element-192" data-mp="1on6t7244xc4a" />
        <link rel="preconnect" href="https://fonts.googleapis.com" data-id="element-193" data-mp="1kj7caiey0bae" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" data-id="element-194" data-mp="1yjryzpnzar96" />
        <link href="https://fonts.googleapis.com/css2?family=Bungee&family=Bricolage+Grotesque:wght@400;500;600;700&family=Instrument+Sans:wght@400;500;600;700&display=swap" rel="stylesheet" data-id="element-195" data-mp="1tjx7pl0ajznl" />
      </Helmet>

      <main className="w-full relative isolate overflow-x-hidden min-h-screen" style={{
      backgroundColor: '#074030'
    }} data-id="element-196" data-mp="23cutq14hs6qy">
        <div className="absolute inset-0 pointer-events-none -z-10" style={{
        backgroundImage: `
              linear-gradient(to right, rgba(255, 255, 255, 0.1) 1px, transparent 1px),
              linear-gradient(to bottom, rgba(255, 255, 255, 0.1) 1px, transparent 1px)
            `,
        backgroundSize: '30px 30px',
        backgroundPosition: '0 0'
      }} data-id="element-197" data-mp="2cchldv7f5y6t" />
        <div className="absolute inset-0 pointer-events-none -z-10" style={{
        backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/bonQpX7FQKEhKvnQfRNJtT/noise-background.png)',
        backgroundRepeat: 'repeat',
        backgroundSize: '200px 200px',
        opacity: 0.24
      }} data-id="element-198" data-mp="1x324quaqtg8x" />

        <div className="absolute top-8 left-8 z-20" data-id="element-199" data-mp="2fs8g1w97j5kp">
          <Link to="/" className="flex items-center gap-3" data-id="element-200" data-mp="2fu1lx9bzxlrn">
            <img src="https://cdn.magicpatterns.com/uploads/8dB8M4GqHB66FgPhzt2tyW/Group_44.png" alt="Fifth Door Logo" className="h-8 w-auto object-contain brightness-0 invert" data-id="element-201" data-mp="2ks39o7kda99g" />
            <span className="text-white text-lg" style={{
            fontFamily: 'Bungee, sans-serif'
          }} data-id="element-202" data-mp="plsr6ge244v5">
              FIFTH DOOR
            </span>
          </Link>
        </div>

        <div className="relative z-10 px-6 py-20 md:py-32 max-w-4xl mx-auto" data-id="element-203" data-mp="toyrz8ieh3u8">
          <h1 className="text-[50px] md:text-[74px] mb-8 text-center" style={{
          fontFamily: 'Bungee, sans-serif',
          color: 'white',
          lineHeight: '1.1'
        }} data-id="element-204" data-mp="18eegehugkx6r">
            DMCA POLICY
          </h1>
          <div className="text-white/70 leading-relaxed text-lg space-y-6" style={{
          fontFamily: "'Instrument Sans', sans-serif"
        }} data-id="element-205" data-mp="1hcyt92dc8cn2">
            <h2 className="text-2xl font-bold text-white mt-4" style={{
            fontFamily: 'Bungee, sans-serif'
          }} data-id="element-206" data-mp="3j8ineg3ewohs">
              NOTIFICATION OF COPYRIGHT INFRINGEMENT
            </h2>

            <p data-id="element-207" data-mp="392r79wvp4hrm">
              Fifth Door Inc. ("Fifth Door") respects the intellectual property
              rights of others and expects its users to do the same.
            </p>

            <p data-id="element-208" data-mp="309xovqkyd29j">
              It is Fifth Door's policy, in appropriate circumstances and at its
              discretion, to disable and/or terminate the accounts of users who
              repeatedly infringe or are repeatedly charged with infringing the
              copyrights or other intellectual property rights of others.
            </p>

            <p data-id="element-209" data-mp="2cdtaya8asbsc">
              In accordance with the Digital Millennium Copyright Act of 1998,
              the text of which may be found on the U.S. Copyright Office
              website at{' '}
              <a href="http://www.copyright.gov/legislation/dmca.pdf" target="_blank" rel="noopener noreferrer" className="text-white underline hover:opacity-80" data-id="element-210" data-mp="aleulflejfe1">
                http://www.copyright.gov/legislation/dmca.pdf
              </a>
              , Fifth Door will respond expeditiously to claims of copyright
              infringement committed using the Fifth Door website (the "Sites")
              that are reported to Fifth Door's Designated Copyright Agent,
              identified in the sample notice below.
            </p>

            <p data-id="element-211" data-mp="1sq22l9pn35by">
              If you are a copyright owner, or are authorized to act on behalf
              of one, or authorized to act under any exclusive right under
              copyright, please report alleged copyright infringements taking
              place on or through the Sites by completing the following DMCA
              Notice of Alleged Infringement and delivering it to Fifth Door's
              Designated Copyright Agent. Upon receipt of the Notice as
              described below, Fifth Door will take whatever action, in its sole
              discretion, it deems appropriate, including removal of the
              challenged material from the Sites.
            </p>

            <h2 className="text-2xl font-bold text-white mt-10" style={{
            fontFamily: 'Bungee, sans-serif'
          }} data-id="element-212" data-mp="3lmxm0ehivtsu">
              DMCA NOTICE OF ALLEGED INFRINGEMENT ("NOTICE")
            </h2>

            <ol className="list-decimal pl-6 space-y-3" data-id="element-213" data-mp="2xwti060f9s1b">
              <li data-id="element-214" data-mp="31wu8wq4pjvp9">
                Identify the copyrighted work that you claim has been infringed,
                or — if multiple copyrighted works are covered by this Notice —
                you may provide a representative list of the copyrighted works
                that you claim have been infringed.
              </li>
              <li data-id="element-215" data-mp="2e6hseqvecqn2">
                Identify the material that you claim is infringing (or to be the
                subject of infringing activity) and that is to be removed or
                access to which is to be disabled, and information reasonably
                sufficient to permit us to locate the material, including at a
                minimum, if applicable, the URL of the link shown on the Site(s)
                where such material may be found.
              </li>
              <li data-id="element-216" data-mp="3r7qaqlg6xhtx">
                Provide your mailing address, telephone number, and, if
                available, email address.
              </li>
              <li data-id="element-217" data-mp="33krunovzgbwj">
                Include both of the following statements in the body of the
                Notice:
                <p className="mt-3 pl-4 border-l-2 border-white/20 italic" data-id="element-218" data-mp="3cjc7i9ev3rcu">
                  "I hereby state that I have a good faith belief that the
                  disputed use of the copyrighted material is not authorized by
                  the copyright owner, its agent, or the law (e.g., as a fair
                  use)."
                </p>
                <p className="mt-3 pl-4 border-l-2 border-white/20 italic" data-id="element-219" data-mp="mt8l0fggyxmn">
                  "I hereby state that the information in this Notice is
                  accurate and, under penalty of perjury, that I am the owner,
                  or authorized to act on behalf of the owner, of the copyright
                  or of an exclusive right under the copyright that is allegedly
                  infringed."
                </p>
              </li>
              <li data-id="element-220" data-mp="1e1savowjplav">
                Provide your full legal name and your electronic or physical
                signature.
              </li>
            </ol>

            <p data-id="element-221" data-mp="1iztq1yqup0h2">
              Deliver this Notice, with all items completed, to Fifth Door's
              Designated Copyright Agent:
            </p>

            <div className="border border-white/10 rounded-xl p-6 bg-white/5 space-y-1" data-id="element-222" data-mp="19aa58njkuwjk">
              <p className="text-white font-semibold" data-id="element-223" data-mp="1x0nzmkpmx7hb">
                Copyright Agent c/o Fifth Door
              </p>
              <p data-id="element-224" data-mp="21reauekqs4jx">
                Email:{' '}
                <a href="mailto:dmca@fifthdoor.com" className="text-white underline hover:opacity-80" data-id="element-225" data-mp="21t7gbqjmciqc">
                  dmca@fifthdoor.com
                </a>
              </p>
              <p data-id="element-226" data-mp="3o46cnnl6k1gy">2261 Market Street STE 22291, San Francisco, CA 94114</p>
            </div>

            <h2 className="text-2xl font-bold text-white mt-10" style={{
            fontFamily: 'Bungee, sans-serif'
          }} data-id="element-227" data-mp="3k34dt7v6drfi">
              COUNTER NOTICES
            </h2>

            <p data-id="element-228" data-mp="fppfdawovboo">
              One who has posted material that allegedly infringes a copyright
              may send Fifth Door a counter notice pursuant to Sections
              512(g)(2) and 512(g)(3) of the DMCA. When Fifth Door receives a
              counter notice, Fifth Door will reinstate the material in question
              in not less than 10 and not more than 14 business days after Fifth
              Door receives the counter notice unless Fifth Door first receives
              notice from the copyright claimant that he/she has filed a legal
              action to restrain the allegedly infringing activity. To provide a
              counter notice to Fifth Door, please return the following form to
              Fifth Door's Designated Copyright Agent. Please note that if you
              provide a counter notice, in accordance with the Fifth Door
              Privacy Policy located at{' '}
              <Link to="/privacy" className="text-white underline hover:opacity-80" data-id="element-229" data-mp="1pm4fhu964v19">
                http://play.fifthdoor.com/privacy
              </Link>{' '}
              and the terms of the DMCA, the counter notice will be given to the
              copyright claimant.
            </p>

            <h3 className="text-xl font-bold text-white mt-6" data-id="element-230" data-mp="56sp6bjmkg4r">
              Counter Notice
            </h3>

            <ol className="list-decimal pl-6 space-y-3" data-id="element-231" data-mp="97un8p1t2m55">
              <li data-id="element-232" data-mp="98nv5tci3hov">
                Identify the material that has been removed or to which access
                has been disabled and the location at which the material
                appeared before it was removed or access to it was disabled.
              </li>
              <li data-id="element-233" data-mp="2af1rntu57cgj">
                Provide your mailing address, telephone number, and, if
                available, email address.
              </li>
              <li data-id="element-234" data-mp="2ke966kcm5d58">
                Include both of the following statements in the body of the
                Notice:
                <p className="mt-3 pl-4 border-l-2 border-white/20 italic" data-id="element-235" data-mp="2ofcl94mu755e">
                  "I hereby state under penalty of perjury that I have a good
                  faith belief that the material was removed or disabled as a
                  result of mistake or misidentification of the material to be
                  removed or disabled."
                </p>
                <p className="mt-3 pl-4 border-l-2 border-white/20 italic" data-id="element-236" data-mp="332xmet05iuao">
                  "I hereby state that I consent to the jurisdiction of the
                  Federal District Court for the judicial district in which my
                  address is located or, if my address is outside of the United
                  States, for any judicial district in which Fifth Door may be
                  found, and I will accept service of process from the
                  complaining party who notified Fifth Door of the alleged
                  infringement or an agent of such person."
                </p>
              </li>
              <li data-id="element-237" data-mp="1a7d9vwx0ftp4">
                Provide your full legal name and your electronic or physical
                signature.
              </li>
            </ol>

            <p data-id="element-238" data-mp="15f3o8t2xhfsn">
              Deliver this Notice, with all items completed, to Fifth Door's
              Designated Copyright Agent:
            </p>

            <div className="border border-white/10 rounded-xl p-6 bg-white/5 space-y-1" data-id="element-239" data-mp="1xyixwzd3tsai">
              <p className="text-white font-semibold" data-id="element-240" data-mp="1t6iqymym9z4f">
                Copyright Agent c/o Fifth Door
              </p>
              <p data-id="element-241" data-mp="3nfxp3f9sfa0y">
                Email:{' '}
                <a href="mailto:dmca@fifthdoor.com" className="text-white underline hover:opacity-80" data-id="element-242" data-mp="3sdprj3826eje">
                  dmca@fifthdoor.com
                </a>
              </p>
              <p data-id="element-243" data-mp="3in4kqsi8e3pe">2261 Market Street STE 22291, San Francisco, CA 94114</p>
            </div>

            <h2 className="text-2xl font-bold text-white mt-10" style={{
            fontFamily: 'Bungee, sans-serif'
          }} data-id="element-244" data-mp="34nlniuqykcrv">
              NOTIFICATION OF TRADEMARK INFRINGEMENT
            </h2>

            <p data-id="element-245" data-mp="2urs5wwydtt38">
              If you believe that your trademark (the "Mark") is being used on
              the Site by a user in a way that constitutes trademark
              infringement, please provide Fifth Door's Designated Copyright
              Agent (specified above) with the following information:
            </p>

            <ol className="list-decimal pl-6 space-y-3" data-id="element-246" data-mp="2ifprsfueqm23">
              <li data-id="element-247" data-mp="2ig7r5lcd9ge8">
                Your full legal name and your electronic or physical signature.
              </li>
              <li data-id="element-248" data-mp="2deiiudgj3gtu">
                Information reasonably sufficient to permit Fifth Door to
                contact you or your authorized agent, including a name, mailing
                address, telephone number and, if available, an email address.
              </li>
              <li data-id="element-249" data-mp="314weedybnxt6">
                Identification of the Mark(s) alleged to have been infringed,
                including (i) for registered Marks, a copy of each relevant
                federal trademark registration certificate or (ii) for common
                law or other Marks, evidence sufficient to establish your
                claimed rights in the Mark, including the nature of your use of
                the Mark, and the time period and geographic area in which the
                Mark has been used by you.
              </li>
              <li data-id="element-250" data-mp="2ub4nq04hczv">
                Information reasonably sufficient to permit Fifth Door to
                identify the use being challenged.
              </li>
              <li data-id="element-251" data-mp="7rulmxo7g3vi">
                Include both of the following statements in the body of the
                Notice:
                <p className="mt-3 pl-4 border-l-2 border-white/20 italic" data-id="element-252" data-mp="cqnxymrr9ou3">
                  "I hereby state that I have not authorized the challenged use,
                  and I have a good-faith belief that the challenged use is not
                  authorized by law."
                </p>
                <p className="mt-3 pl-4 border-l-2 border-white/20 italic" data-id="element-253" data-mp="3l67pnhcs2z71">
                  "I hereby state under penalty of perjury that all of the
                  information in the notification is accurate and that I am the
                  owner of the Mark, or authorized to act on behalf of the owner
                  of the Mark."
                </p>
              </li>
            </ol>

            <p data-id="element-254" data-mp="31i8alub6l5vt">
              Upon receipt of notice as described above, Fifth Door will seek to
              confirm the existence of the Mark on the Sites, notify the
              registered user who posted the content including the Mark, and
              take whatever action, in its sole discretion, it deems
              appropriate, including temporary or permanent removal of the Mark
              from the Sites.
            </p>

            <h2 className="text-2xl font-bold text-white mt-10" style={{
            fontFamily: 'Bungee, sans-serif'
          }} data-id="element-255" data-mp="2b27m83u61e8i">
              NOTIFICATION OF OTHER INTELLECTUAL PROPERTY ("IP") INFRINGEMENT
            </h2>

            <p data-id="element-256" data-mp="1xaj8jw49qhpf">
              If you believe that some other IP right of yours is being
              infringed by a user, please provide Fifth Door's Designated
              Copyright Agent (specified above) with the following information:
            </p>

            <ol className="list-decimal pl-6 space-y-3" data-id="element-257" data-mp="1ncvd13yu9667">
              <li data-id="element-258" data-mp="1do7xdp9u6wcc">
                Your full legal name and your electronic or physical signature.
              </li>
              <li data-id="element-259" data-mp="1iovmu6if354g">
                Information reasonably sufficient to permit Fifth Door to
                contact you or your authorized agent, including a name, mailing
                address, telephone number and, if available, an email address.
              </li>
              <li data-id="element-260" data-mp="1wfil5xk9mt00">
                Identification of the IP alleged to have been infringed,
                including (i) a complete description or explanation of the
                nature of the IP, (ii) evidence that you own the IP in the
                relevant jurisdiction, including copies of relevant patents,
                registrations, certifications or other documentary evidence of
                your ownership, and (iii) a showing sufficient for Fifth Door to
                determine without unreasonable effort that the IP has been
                infringed.
              </li>
              <li data-id="element-261" data-mp="8pb3upnwjg4l">
                Information reasonably sufficient to permit Fifth Door to
                identify the use being challenged.
              </li>
              <li data-id="element-262" data-mp="3ond853l51aw">
                Include both of the following statements in the body of the
                Notice:
                <p className="mt-3 pl-4 border-l-2 border-white/20 italic" data-id="element-263" data-mp="dgkqdhe5m3c9">
                  "I hereby state that I have not authorized the challenged use,
                  and I have a good-faith belief that the challenged use is not
                  authorized by law."
                </p>
                <p className="mt-3 pl-4 border-l-2 border-white/20 italic" data-id="element-264" data-mp="3ux2muwhfvp8u">
                  "I hereby state under penalty of perjury that all of the
                  information in the notification is accurate and that I am the
                  owner of the IP, or authorized to act on behalf of the owner
                  of the IP."
                </p>
              </li>
            </ol>

            <p data-id="element-265" data-mp="167kurtged94g">
              Upon receipt of notice as described above, Fifth Door will seek to
              confirm the existence of the IP on the Sites, notify the user who
              posted the content including the IP, and take whatever action, in
              its sole discretion, it deems appropriate, including temporary or
              permanent removal of the IP from the Sites.
            </p>
          </div>
        </div>
      </main>

      <Footer data-id="element-266" data-mp="3idnh59rpxfvd" />
    </>;
}